<template>
    <a :href="href" class="site-logo d-inline-block">
        <div class="site-logo__inner d-flex align-center">
            <img :src="logo" alt="Kolumbus logo" class="site-logo__image" />
        </div>
    </a>
</template>

<script setup lang="ts">
import logo from '@geta/kolumbus-assets/dist/logo.svg';

defineProps({ href: { type: String, default: '/' } });
</script>

<style lang="scss">
@use 'vuetify/settings' as *;
@use 'vuetify/lib/styles/tools/_index' as *;
@use 'sass:map';

.site-logo {
    &__inner {
        overflow: hidden;
        height: 20px;
        width: 110px;

        @media #{map.get($display-breakpoints, 'md-and-up')} {
            height: 24px;
            width: 140px;
        }
    }

    &__image {
        display: block;
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
    }
}
</style>
